/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/display-name */
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { CanvasRefs, ClamshellPreviewProps, Styled } from '.';
import { useI18n } from 'contexts/i18n';

const ClamshellPreview = forwardRef<CanvasRefs, ClamshellPreviewProps>(
  (
    {
      createPreview,
      displayDrawingAreaOutline,
      displayLogoHelperText,
      displayQrCodeHelperText,
    },
    ref
  ) => {
    const previewCanvasContainerRef = useRef<HTMLDivElement>(null);
    const logoCanvasContainerRef = useRef<HTMLCanvasElement>(null);
    const qrCodeCanvasContainerRef = useRef<HTMLCanvasElement>(null);
    const i18n = useI18n();
    useImperativeHandle(ref, () => ({
      //@ts-ignore to ignore the error after updating to nextjs 15
      previewCanvasContainerRef,
      //@ts-ignore to ignore the error after updating to nextjs 15
      logoCanvasContainerRef,
      //@ts-ignore to ignore the error after updating to nextjs 15
      qrCodeCanvasContainerRef,
    }));

    return (
      <>
        <Styled.ClamshellPreview show={true}>
          <Styled.ClamshellPreviewImage ref={previewCanvasContainerRef}>
            <img
              src="/images/backcase.png"
              height="510px"
              width="510px"
              alt="Backcase Image"
            />

            <Styled.LogoDrawingArea showBorder={displayDrawingAreaOutline}>
              <Styled.HelperText
                displayText={displayLogoHelperText}
                className="logoWrapper"
              >
                {i18n['Logo Here']}
              </Styled.HelperText>

              <canvas
                width="300px"
                height="110px"
                ref={logoCanvasContainerRef}
              ></canvas>
            </Styled.LogoDrawingArea>
            <Styled.QRCodeDrawingArea showBorder={displayDrawingAreaOutline}>
              <Styled.HelperText
                displayText={displayQrCodeHelperText}
                className="qrCodeWrapper"
              >
                {i18n['URL & QR Code Here']}
              </Styled.HelperText>
              <canvas
                width="300px"
                height="110px"
                ref={qrCodeCanvasContainerRef}
              ></canvas>
            </Styled.QRCodeDrawingArea>
          </Styled.ClamshellPreviewImage>
        </Styled.ClamshellPreview>
      </>
    );
  }
);

export default ClamshellPreview;
